import {useRouter} from 'next/router';
import {type Dispatch, type SetStateAction, useEffect} from 'react';
import type {IndustryCategoriesReturnValueType} from '../../../core/repositories/reportsRepository';

export const getIndustriesFromURL = (
  industryCategories: IndustryCategoriesReturnValueType | undefined,
  setFilterCategories: Dispatch<SetStateAction<number[]>>,
) => {
  const router = useRouter();
  const {industries} = router.query;
  const industriesStr = String(industries);
  useEffect(() => {
    if (industryCategories?.ok) {
      const newFilterItems: number[] = industriesStr
        ? industriesStr
            .split(',')
            .map((id) => Number.parseInt(id, 10))
            .filter((id) => !Number.isNaN(id))
        : [];
      setFilterCategories(newFilterItems);
    }
  }, [industryCategories]);
};
